import { CIcon } from '~/icons/types'

export const ciCalculator: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M18 22.5H6A2.5 2.5 0 0 1 3.5 20V4A2.5 2.5 0 0 1 6 1.5h12A2.5 2.5 0 0 1 20.5 4v16a2.5 2.5 0 0 1-2.5 2.5ZM6 2.5A1.5 1.5 0 0 0 4.5 4v16A1.5 1.5 0 0 0 6 21.5h12a1.5 1.5 0 0 0 1.5-1.5V4A1.5 1.5 0 0 0 18 2.5H6Z'
    },
    {
      d:
        'M16 6.5H8a.5.5 0 1 1 0-1h8a.5.5 0 0 1 0 1ZM16 18.5a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 1 0v4a.5.5 0 0 1-.5.5ZM16 10.5a.5.5 0 1 1 .343-.146.5.5 0 0 1-.353.146H16ZM12 10.5a.5.5 0 1 1 .344-.146.5.5 0 0 1-.354.146H12ZM8 10.5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1ZM12 14.5a.5.5 0 1 1 .344-.146.5.5 0 0 1-.354.146H12ZM8 14.5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1ZM12 18.5a.5.5 0 1 1 .344-.146.5.5 0 0 1-.354.146H12ZM8 18.5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Z'
    }
  ],
  name: 'calculator',
  type: 'thin'
}
